import PropTypes from "prop-types";

import config from "../../../config/index";
import labels from "../../../config/labels";
import { CustomContainer } from "../../atoms/DependencyHelper";
import FormHeading from "../../atoms/checkoutForms/formHeading/FormHeading";
import ItemsDetails from "../../molecules/reviewOrder/itemsDetails/ItemsDetails";
import InfoBox from "../../atoms/infoBox/InfoBox";
import styles from "./CheckoutReview.module.scss";

const ReviewItems = ({
  title,
  price,
  itemLabel,
  priceLabel,
  customerStatus,
  cartProducts,
  cartId,
  isDeal,
  showOnceOff,
}) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;

  return (
    <CustomContainer className={styles["purchase"]}>
      <FormHeading
        title={title}
        className={styles["top-wrapper"]}
        headingClassName={styles["top-wrapper__heading"]}
      />
      {isDeal && showOnceOff ? <InfoBox
        type="success"
        className={styles["success-msg"]}
        imageSrc={`${imagePrefix}/assets/images/success-circle-white.svg`}
        imageWidth="1.3125rem"
        imageHeight="1.3125rem"
        text={itemLabel === "Upgrade" ? labels.lbl_success_auth : labels.lbl_success_approved}
      /> : null}
      <ItemsDetails
        customerStatus={customerStatus}
        cartProducts={cartProducts}
        cartId={cartId}
        className={styles["section"]}
        itemLabel={itemLabel}
        price={price}
        priceLabel={priceLabel}
      />
    </CustomContainer>
  );
};

ReviewItems.propTypes = {
  title: PropTypes.string,
  price: PropTypes.string,
  itemLabel: PropTypes.string,
  priceLabel: PropTypes.string,
  customerStatus: PropTypes.string,
  cartProducts: PropTypes.arrayOf(PropTypes.object),
  cartId: PropTypes.string,
  isDeal: PropTypes.bool,
  showOnceOff: PropTypes.bool,
};

export default ReviewItems;
